const colourStyles = {
  control: (provided, { isFocused }) => ({
    ...provided,
    borderColor: isFocused
      ? 'rgb(var(--ow-primary-color)) !important'
      : '#d9d9d9',
    backgroundColor: '#fff',
    boxShadow: isFocused
      ? '0 0 0 3px rgba(var(--ow-primary-color),.10)'
      : 'none',
    ':active': {
      ...provided[':active'],
      borderColor: 'rgb(var(--ow-primary-color))',
      borderBottomLeftRadius: '0px',
    },
    ':hover': {
      ...provided[':hover'],
      borderColor: 'rgb(var(--ow-border-color))',
    },
  }),
  indicatorSeparator: (styles) => ({
    ...styles,
    width: '0',
  }),
  indicatorsContainer: (styles) => ({
    ...styles,
  }),
  placeholder: (styles) => ({
    ...styles,
    fontSize: '0.8125rem',
    color: 'var(--ow-color-gray-300)',
  }),
  valueContainer: (styles) => ({
    ...styles,
    flexWrap: 'nowrap',
  }),
  menu: (styles) => ({
    ...styles,
    background: '#ffffff',
    borderRadius: '2px',
    boxShadow: '0px 3px 12px 0px rgba(var(--ow-primary-color),0.1)',
    marginTop: '4px',
    marginBottom: '0',
    zIndex: '1000',
  }),
  menuList: (styles) => ({
    ...styles,
    pdddingTop: '0',
  }),
  option: (styles, { isDisabled, isSelected }) => {
    return {
      ...styles,
      // eslint-disable-next-line no-nested-ternary
      backgroundColor: isSelected ? 'var(--ow-color-primary-50)' : '#fff',
      width: '100%',
      height: '36px',
      display: 'flex',
      alignItems: 'center',
      color: isDisabled ? '#ccc' : 'black',
      cursor: isDisabled ? 'not-allowed' : 'default',
      padding: '2px 8px',
      ':active': {
        ...styles[':active'],
        backgroundColor: 'var(--ow-color-primary-50)',
      },
      ':hover': {
        ...styles[':active'],
        backgroundColor: 'var(--ow-color-primary-50)',
      },
    }
  },
}

export const multiSelectStyles = (style = {}) => {
  return {
    ...colourStyles,
    multiValue: (styles) => {
      return {
        ...styles,
        paddingLeft: '0.6875rem',
        paddingRight: '0.6875rem',
        borderRadius: '0.875rem',
        fontSize: '0.875rem',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        minWidth: '89px',
      }
    },
    multiValueLabel: (styles) => {
      return {
        ...styles,
        paddingLeft: '0',
        marginRight: '0.6875rem',
      }
    },
    multiValueRemove: (styles) => ({
      ...styles,
      padding: '0',
      ':hover': {
        backgroundColor: 'none',
        color: '#fff',
      },
    }),
    valueContainer: (styles) => ({
      ...styles,
      overflowX: 'visible',
      flexWrap: 'nowrap',
    }),
    control: (styles, { isFocused }) => ({
      ...styles,
      width: style.width || '235px',
      minHeight: style.height || '34px',
      height: style.height || '34px',
      borderTopLeftRadius: style.borderTopLeftRadius,
      borderBottomLeftRadius: style.borderBottomLeftRadius,
      borderColor: isFocused
        ? 'rgb(var(--ow-primary-color)) !important'
        : '#d9d9d9',
      backgroundColor: '#fff',
      boxShadow: isFocused
        ? '0 0 0 3px rgba(var(--ow-primary-color),.10)'
        : 'none',
      ':active': {
        ...styles[':active'],
        borderColor: 'rgb(var(--ow-primary-color))',
        borderBottomLeftRadius: '0px',
      },
      ':hover': {
        ...styles[':hover'],
        borderColor: 'rgb(var(--ow-border-color))',
      },
    }),
  }
}

const dot = () => ({
  alignItems: 'center',
  display: 'flex',
})

export const singleSelectStyles = (style = {}) => {
  return {
    ...colourStyles,
    input: (styles) => ({ ...styles, ...dot() }),
    singleValue: (styles, { data }) => ({ ...styles, ...dot(data.color) }),
    control: (styles, { isFocused }) => {
      return {
        ...styles,
        width: style.width || '235px',
        minHeight: style.height || '34px',
        height: style.height || '34px',
        borderTopLeftRadius: style.borderTopLeftRadius,
        borderBottomLeftRadius: style.borderBottomLeftRadius,
        borderColor: isFocused
          ? 'rgb(var(--ow-primary-color)) !important'
          : '#dbdfea',
        backgroundColor: '#fff',
        boxShadow: isFocused
          ? '0 0 0 3px rgba(var(--ow-primary-color),.10)'
          : 'none',
        ':active': {
          ...styles[':active'],
          borderColor: 'rgb(var(--ow-primary-color))',
          borderBottomLeftRadius: '0px',
        },
        ':hover': {
          ...styles[':hover'],
          borderColor: 'rgb(var(--ow-border-color))',
        },
      }
    },
  }
}
